export class MaskCPF {
    cpf_cnpj = '';
    DECIMAL_SEPARATOR = ".";
    GROUP_SEPARATOR = ",";
    pureResult: any;
    maskedId: any;
    val: any;
    v: any;

    unFormat(val) {
        if (!val) {
            return '';
        }
        val = val.replace(/\D/g, '');

        if (this.GROUP_SEPARATOR === ',') {
            return val.replace(/,/g, '');
        } else {
            return val.replace(/\./g, '');
        }
    };

    cpf_mask(v) {
        v = v ? v : ""
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }

    format(valString) {
        if (!valString) {
            return '';
        }
        let val = valString.toString();
        let unformat = this.unFormat(val)
        if (Number(unformat)) {
            const parts = unformat.split(this.DECIMAL_SEPARATOR);
            this.pureResult = parts;
            if (parts[0].length <= 11) {
                this.maskedId = this.cpf_mask(parts[0]);
                return this.maskedId;
            }
        }
        return val
    }
}